import { getScriptParamsByURL as f } from "@fast-simon/common";
const SCRIPTS = ["fast-simon-autocomplete-init", "acp-magento.js", "instantsearchplus.com/js/loader.js"];
export default function getScriptParamsByURL() {
    for (const option of SCRIPTS) {
        const paramsHead = f(option);
        const paramsBody = f(option, document.body);
        if (paramsHead && paramsBody) {
            return Object.assign(Object.assign({}, paramsHead), paramsBody);
        }
        if (paramsHead || paramsBody) {
            return paramsHead || paramsBody;
        }
    }
    return null;
}
//# sourceMappingURL=getScriptParamsByURL.js.map